module.exports = __webpack_public_path__ + "img/edelstahltreppengelaender.4172b550.jpg";